import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { SessionProvider, useSession } from "./hooks/useSession";
import Landing from "./pages/Landing";
import About from "./pages/About";
import Workspace from "./pages/Workspace";
import Auth from "./pages/Auth";
import ClosedBeta from "./pages/ClosedBeta";
import ComponentTest from "./pages/ComponentTest";
import { TaskListDemo } from "./pages/TaskListDemo";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

// Default: require auth. Renders children if authenticated, redirects if not.
function AuthRequired() {
  const { user, isLoading } = useSession();
  if (isLoading) return <div className="h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>;
  return user ? <Outlet /> : <Navigate to="/auth" replace />;
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <SessionProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            {/* Everything under AuthRequired needs authentication */}
            <Route element={<AuthRequired />}>
              <Route path="/" element={<Landing />} />
              <Route path="/workspace" element={<Workspace />} />
              <Route path="/test" element={<ComponentTest />} />
              <Route path="/tasklist" element={<TaskListDemo />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            
            {/* Only these are public (explicitly outside AuthRequired) */}
            <Route path="/closed-beta" element={<ClosedBeta />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </SessionProvider>
  </QueryClientProvider>
);

export default App;
